<template>
    <x-app class="layout-auth-sample"></x-app>
</template>

<script>
export default {
    name: 'LayoutAuthSample',
    components: {
    },
    data() {
        return {}
    },
    methods: {
        openExternalPath(app) {
            const route = this.$router.resolve({ path: app.path });
            window.open(route.href, '_blank');
        },
    },
}
</script>

<style scoped>
.fade-enter{
    opacity: 0;
}
.fade-enter-active{
    transition: all .4s ease;
}
</style>
